import React from "react";

export default function BlogComponent({ sections = [], onRegenerate, onEdit }) {
  return (
    <div className="blog-outline-root">
      {sections.map((section, idx) => (
        <div className="outline-section-item" key={idx}>
          <div className="section-header">
            <h4>{section.title}</h4>
            <div className="section-actions">
              <button onClick={() => onRegenerate?.(idx)} className="action-button">
                <i className="fas fa-redo"></i> Regenerate textttetetete
              </button>
              <button onClick={() => onEdit?.(idx)} className="action-button">
                <i className="fas fa-edit"></i> Edit text
              </button>
              <button className="action-button delete">
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
          <ul>
            {Array.isArray(section.points) && section.points.map((point, pointIndex) => (
              <li key={pointIndex}>{point}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
